import { AxiosResponse } from 'axios';
import {
  CreateAttachmentAndGenerateUploadUrlForTenantPortalRequest,
  CreateAttachmentAndGenerateUploadUrlRequest,
  CreateAttachmentAndGenerateUploadUrlResponse,
  GetAttachmentExpiringUrlByIdResponse,
} from 'vendor-marketplace-shared-library';

import http from './http-common';

class AttachmentService {
  async createAttachmentAndGenerateUploadUrl(
    fileName: string,
    fileType: string,
  ): Promise<AxiosResponse<CreateAttachmentAndGenerateUploadUrlResponse>> {
    return http.post('/attachment', {
      fileName,
      fileType,
    } as CreateAttachmentAndGenerateUploadUrlRequest);
  }

  async tenantCreateAttachmentAndGenerateUploadUrl(
    fileName: string,
    fileType: string,
    formHash: string,
    submissionId: string,
    displayName?: string,
  ): Promise<AxiosResponse<CreateAttachmentAndGenerateUploadUrlResponse>> {
    return http.post('/tenant/work-order/upload-attachment', {
      fileName,
      fileType,
      formHash,
      submissionId,
      displayName,
    } as CreateAttachmentAndGenerateUploadUrlForTenantPortalRequest);
  }

  async tenantFileUpload(file: File, formHash: string, submissionId: string): Promise<number> {
    const response = await this.tenantCreateAttachmentAndGenerateUploadUrl(
      file.name,
      file.type,
      formHash,
      submissionId,
    );
    const uploadUrl: string = response.data.url;
    const attachmentId: number = response.data.attachmentId;

    await http.put(uploadUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    });

    return attachmentId;
  }

  async fileUpload(file: File): Promise<number> {
    const response = await this.createAttachmentAndGenerateUploadUrl(file.name, file.type);
    const uploadUrl: string = response.data.url;
    const attachmentId: number = response.data.attachmentId;

    await http.put(uploadUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    });

    return attachmentId;
  }

  async getExpiringUrl(
    attachmentId: number,
  ): Promise<AxiosResponse<GetAttachmentExpiringUrlByIdResponse>> {
    return http.get(`/attachment/${attachmentId}/expiring-url`);
  }
}

const attachmentService = new AttachmentService();

export default attachmentService;
